import { PrimaryButton,TextField,Stack,Text, Label,DefaultEffects,Nav } from '@fluentui/react';
import React,{useState } from 'react';
import Stock from '../stock';
import BMI from '../BMI';
import Length from '../length';

function Content(props){
    const contentType = props.contentType;
    let content;
    if(contentType == 'stock')
    {
        content = <Stock />
    }
    else if(contentType == 'BMI')
    {
        content = <BMI />
    }
    else if(contentType == 'length')
    {
        content = <Length />
    }
    else 
    {
        content = <h1>hello~</h1>
    }
    return(
        <Stack tokens={{ maxWidth:800,padding:40 }} style={{ boxShadow: DefaultEffects.elevation8,backgroundColor:'white'}} wrap>
           {content}
        </Stack>
    );
}

export default Content;